import React from 'react';
import LeftForm from '../../Components/Forms/LeftForm';
import RightTable from '../../Components/Tables/RightTable';
import ClientForm from '../../Components/Forms/LeftFormInputs';

const leftColumns = [
  [
    {
      Header: 'Client',
      accessor: 'client',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'No client',
      accessor: 'code_casa',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'No civic, Rue',
      accessor: 'address',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'Ville, Province',
      accessor: 'city',
      inputType: 'text',
    },
    {
      Header: 'Code postal',
      accessor: 'postal_code',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'Pays',
      accessor: 'country',
      inputType: 'text',
    },
    {
      Header: 'Temps Google',
      accessor: 'distance',
      inputType: 'text',
    },
  ],
  [
    {
      Header: 'Contact',
      accessor: 'contact',
      inputType: 'text',
    },
    {
      Header: 'Mobile',
      accessor: 'mobile_phone',
      inputType: 'text',
    },
    {
      Header: 'Tél. Bureau',
      accessor: 'phone',
      inputType: 'text',
    },
    {
      Header: 'Référence',
      accessor: 'reference',
      inputType: 'text',
    },
    {
      Header: 'Représentant',
      accessor: 'representant',
      inputType: 'text',
    },
  ],
  [
    {
      Header: 'No de projet',
      accessor: 'prd_id',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'No de séquence',
      accessor: 'sequence',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'Étape',
      accessor: 'step',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'Ressource',
      accessor: 'resource',
      inputType: 'text',
    },
    {
      Header: 'Description',
      accessor: 'description',
      inputType: 'text',
    },
    {
      Header: 'Notes détails',
      accessor: 'note',
      inputType: 'text',
    },
    {
      Header: 'Note interne',
      accessor: 'note_csv',
      inputType: 'text',
    },
  ],
];

const rightColumns = [
  {
    Header: 'Proj.',
    accessor: 'prd_id',
    width: 100,
  },
  {
    Header: 'client',
    accessor: 'client',
    minWidth: 300,
  },
  {
    Header: 'Séq.',
    accessor: 'sequence',
    width: 50,
  },
  {
    Header: 'Ét.',
    accessor: 'step',
    width: 50,
  },
  {
    Header: 'Ress.',
    accessor: 'resource',
    width: 50,
  },
  {
    Header: 'Contact',
    accessor: 'contact',
  },
  {
    Header: 'Représentant',
    accessor: 'representant',
  },
];

const Clients = () => (
  <React.Fragment>
    <LeftForm title="Créer un nouveau client" model="clients">
      <ClientForm columns={leftColumns} model="clients" />
    </LeftForm>
    <RightTable
      title="Liste de clients"
      model="clients"
      columns={rightColumns}
    />
  </React.Fragment>
);

export default Clients;
